export const BOUNDING_BOXES_COLORS = [
  // Dark blue
  "#1f77b4",

  // Dark orange
  "#ff7f0e",

  // Dark green
  "#2ca02c",

  // Dark red
  "#d62728",

  // Dark purple
  "#9467bd",

  // Dark brown
  "#8c564a",

  // Dark gray
  "#7f7f7f",

  // Dark pink
  "#e377c2",

  // Dark lima
  "#bcbd22",

  // Dark sky
  "#17becf",

  // Light blue
  "#aec7e8",

  // Light orange
  "#ffbb78",

  // Light green
  "#97df8a",

  // Light red
  "#ff9896",

  // Light purple
  "#c5b0d5",

  // Light brown
  "#c49c94",

  // Light pink
  "#f7b6d2",

  // Light gray
  "#c7c7c7",

  // Light lima
  "#dada8d",

  // Light sky
  "#9edae5",
];
